import { useState } from 'react';
import { isBoolean, useDebouncedEffect } from '@anton.bobrov/react-hooks';
import { useScrollView } from './useScrollView';
/**
 * ScrollView hook that helps you detect elements in or out of viewport
 */
export function useScrollViewAnimationTrigger(_a) {
    var ref = _a.ref, _b = _a.animation, animation = _b === void 0 ? 'view' : _b, inViewDelay = _a.inViewDelay;
    var _c = useState(false), isActive = _c[0], setIsActive = _c[1];
    useScrollView({
        ref: ref,
        onIn: function () { return setIsActive(true); },
        onOut: function () { return setIsActive(false); },
        isDisabled: animation !== 'view',
        inDelay: inViewDelay,
    });
    useDebouncedEffect(function () {
        if (!isBoolean(animation)) {
            return;
        }
        setIsActive(animation);
    }, [animation], inViewDelay !== null && inViewDelay !== void 0 ? inViewDelay : 0);
    return { isActive: isActive };
}
//# sourceMappingURL=useScrollViewAnimationTrigger.js.map